// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","menu":"Footer_menu__CyDwl","copyright":"Footer_copyright__2WB24"};